import React, { Component } from 'react';
import { ListLayout, TableLayout } from '../containers/Layout';
import { isEmpty } from "lodash";
import { TableRow, TableCell, Button, TableBody, TableHead, IconButton } from '@material-ui/core';
import { EditRounded, PersonAdd, SettingsRounded, WidgetsRounded, RemoveShoppingCartRounded } from '@material-ui/icons';

class ListShop extends Component {
    state = {  }

    normalizeStr = (str) => {// remove accent and lower case str
        if(!isEmpty(str)){
            str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
        }
        return str
    }

    findUserName = (user_id) =>{
        const { USERS } = this.props
        if (user_id===""){
            return ""
        }
        if (USERS){
            let userInfo = Object.values(USERS).filter( user => {if (user.userID===user_id){return true} })
            if(userInfo.length === 1){
                return userInfo[0].name
            }
        }
        return ""
    }

    createShopList = () => {
        const { SHOPS } = this.props
        const strPays = this.normalizeStr(this.props.search.searchPays)
        const strVille = this.normalizeStr(this.props.search.searchVille)

        let filteredList = Object.values(SHOPS).filter( shop => {
            const dbPays = this.normalizeStr(shop.country)
            const dbVille = this.normalizeStr(shop.city)
            if (!strVille && !strPays ){
                return true
            } else if (strVille) {
                return dbVille.indexOf(strVille) !== -1
            } else if (strPays){
                return dbPays.indexOf(strPays) !== -1
            } else {
                return (dbVille.indexOf(strVille) !== -1 ) && (dbPays.indexOf(strPays) !== -1)
            } 
        })
        console.log({filteredList});
        filteredList.sort((a, b) => (a.shop_disabled === b.shop_disabled) ? 0 : a.shop_disabled ? 1 : -1);
        return filteredList.map( shop => (
            <TableRow key={shop.id} 
                style={{
                    textDecoration: shop.shop_disabled ? "line-through" : undefined,
                    color: shop.shop_disabled ? "grey" : undefined,
                    fontStyle: shop.shop_disabled ? "italic" : undefined,
                    textDecorationThickness: shop.shop_disabled ? "2px" : "auto"
                }}
            >
                <TableCell>{shop.shop_ref}</TableCell>
                <TableCell>
                    <a 
                        href="#" 
                        onClick={
                            () => this.props.handleSingle(shop) 
                        }
                    >{shop.name}</a>
                </TableCell>
                <TableCell>{shop.city}</TableCell>
                <TableCell>{shop.country}</TableCell>
                <TableCell>{this.findUserName(shop.shop_manager)}</TableCell>
                <TableCell>
                    <IconButton
                        color="secondary" 
                        onClick={
                            ()=> this.props.handleUpdate(shop)
                        }
                    >
                        <EditRounded />
                    </IconButton>
                
                    <IconButton
                        color="secondary" 
                        onClick={
                            () => this.props.handleCreateLoc(shop)
                        }
                        disabled={!!shop.local_id}
                    >
                        <WidgetsRounded />
                    </IconButton> 
                    <IconButton
                        color="secondary" 
                        onClick={
                            () => this.props.handleUpdateManager(shop)
                        }
                    >
                        <PersonAdd />
                    </IconButton>
                    <IconButton
                        color="secondary" 
                        title="Vider le magasin"
                        onClick={
                            () => this.props.handleEmptyShop(shop)
                        }
                    >
                        <RemoveShoppingCartRounded />
                    </IconButton>
                </TableCell>
            </TableRow>
        ))
    }

    render() {
        const { SHOPS } = this.props;
        return (
            
            <TableLayout>
                <TableHead>
                    <TableRow>
                        <TableCell component="th">Réference</TableCell>
                        <TableCell component="th">Nom</TableCell>
                        <TableCell component="th">Ville</TableCell>
                        <TableCell component="th">Pays</TableCell>
                        <TableCell component="th">Manageur</TableCell>
                        <TableCell component="th">Options</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!isEmpty(SHOPS) && 
                        this.createShopList()
                    }
                </TableBody>
            </TableLayout>

        );
    }
}

export default ListShop;